var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$options.name},[_c('div',{class:`${_vm.$options.name}__count : ${_vm.$options.name}__elem`},[_vm._v(" "+_vm._s(_vm.totalAnswerSheets)+" ")]),_c('div',{class:`${_vm.$options.name}__text : ${_vm.$options.name}__elem`},[_vm._v(" ชุดข้อสอบ ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }